<cjm-layout-container
	class="c-we-grow-together-section"
	asidePosition="right"
	alignItems="center"
	classesMain="c-we-grow-together-section__content"
	[layoutType]="assetUrl ? 'split-equal' : 'full-width'"
>
	<ng-container main>
		<h2 class="c-vloket-header c-vloket-header--h2" cypressTag="General.Header.H2">
			<span class="c-vloket-text-marking c-vloket-text-marking--line-through">
				{{ i18nKeys.Home.WeGrowTogetherSection.Title | translate }}</span
			>
		</h2>

		<div [outerHTML]="i18nKeys.Home.WeGrowTogetherSection.Text | translate"></div>

		<cjm-link
			to="https://us13.list-manage.com/contact-form?u=7558bdab8114a52b4e9c66d8e&form_id=5a64a1f78541d4e2f744f7f0593420ef"
			type="external"
			[title]="i18nKeys.Home.WeGrowTogetherSection.Button.Title | translate"
			[classes]="buttonClasses.LinkButton"
		>
			{{ i18nKeys.Home.WeGrowTogetherSection.Button.Text | translate }}
		</cjm-link>
	</ng-container>
	<div class="c-we-grow-together-section__image" asideRight>
		<cjm-img [src]="assetUrl" />
	</div>
</cjm-layout-container>
